import { AlertBar, Link, Text } from '~/components/granular';
import { GranularLogoAlt } from '~/components/icons';
import { FormattedMessage } from '~/intl';

const IS_PROD = import.meta.env.PROD;

interface BaseErrorProps {
  title: string;
  message?: string;
  stack?: string;
}

export function BaseError({ title, message, stack }: BaseErrorProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <GranularLogoAlt height={53} width={125} />
      <div className="mt-10">
        <AlertBar appearance="error" size="small" text={message} title={title} />
        <div className="mt-4 text-center">
          <Text as="p" color="secondary" variant="value">
            <FormattedMessage id="error.UNKNOWN" />
          </Text>
          <Link href="mailto: support@granular-energy.com">support@granular-energy.com</Link>
        </div>
      </div>

      {!IS_PROD ? (
        <div className="mx-auto mt-12 w-2/3 rounded-lg bg-red-100 p-6">
          <pre className="overflow-auto text-xs">{stack}</pre>
        </div>
      ) : null}
    </div>
  );
}
